var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 4v1H5V4zM3 4.5C3 5.327 2.327 6 1.5 6S0 5.327 0 4.5.673 3 1.5 3 3 3.673 3 4.5m-1 0a.5.5 0 1 0-1.002.002A.5.5 0 0 0 2 4.5M5 9h12V8H5zm-2-.5c0 .827-.673 1.5-1.5 1.5S0 9.327 0 8.5.673 7 1.5 7 3 7.673 3 8.5m-1 0a.5.5 0 1 0-1.002.002A.5.5 0 0 0 2 8.5M5 13h12v-1H5zm-2-.5c0 .827-.673 1.5-1.5 1.5S0 13.327 0 12.5.673 11 1.5 11s1.5.673 1.5 1.5m-1 0a.5.5 0 1 0-1.002.002A.5.5 0 0 0 2 12.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/toc.svg";